<div class="global-container">
  <div class="container-menu">
    <app-new-menu></app-new-menu>
  </div>
  <div class="container-content">
    <div class="headercontent">
      <app-header
        class="container-header d-flex align-items-start"
      ></app-header>
    </div>
    <nav class="router">
      <app-new-breadcrumb></app-new-breadcrumb>
      <router-outlet></router-outlet>
    </nav>
  </div>
</div>
